import { HttpClient } from '@angular/common/http';
import { Comment } from '@app/shared/models/post';
import { environment } from '@env/environment';
import { Observable, catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';

export class ChatApi {
  private apiUrl = environment.API_URL;
  constructor(
    public readonly httpClient: HttpClient,
    public config: ApiClientConfig
  ) { }

  getPendingTotal(): Observable<Comment[]> {
    return this.httpClient
      .get<any>(`${this.apiUrl}/chat/sessions/support/status/PENDING/count?module=SOCIAL`)
      .pipe(
        timeout(this.config.responseTimeout),
        map((res: any) => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
